module.exports = __webpack_public_path__ + "media/images/webSite-ff3da89aed563caca95c9617cad48158.svg";